import { $api } from "@/kibi/core/utils/api";
import type { InjectionKey } from "vue";
import type {
  EmailTemplateResponse,
  SaveEmailTemplateRequest,
  TemplateListItem,
} from "../models/template_model";

export interface TemplateDataSource {
  getOrgTemplates(lang?: string): Promise<EmailTemplateResponse[]>;
  listTemplates(): Promise<TemplateListItem[]>;
  getTemplateDetails(
    lang: string,
    code: string,
  ): Promise<EmailTemplateResponse>;
  saveTemplate(request: SaveEmailTemplateRequest): Promise<void>;
}

export const templateDataSourceKey: InjectionKey<TemplateDataSource> =
  Symbol("TemplateDataSource");

export class TemplateDataSourceImpl implements TemplateDataSource {
  async getOrgTemplates(lang: string = "en"): Promise<EmailTemplateResponse[]> {
    const response = await $api<{
      message: string;
      data: EmailTemplateResponse[];
    }>("/emails/templates/org", {
      method: "GET",
      params: { lang },
    });
    return response.data;
  }

  async listTemplates(): Promise<TemplateListItem[]> {
    const response = await $api<{
      message: string;
      data: TemplateListItem[];
    }>("/emails/templates", {
      method: "GET",
    });
    return response.data;
  }

  async getTemplateDetails(
    lang: string,
    code: string,
  ): Promise<EmailTemplateResponse> {
    const response = await $api<{
      message: string;
      data: EmailTemplateResponse;
    }>("/emails/templates/details", {
      method: "GET",
      params: { lang, code },
    });
    return response.data;
  }

  async saveTemplate(request: SaveEmailTemplateRequest): Promise<void> {
    await $api("/emails/templates", {
      method: "POST",
      body: request,
    });
  }
}
